// extracted by mini-css-extract-plugin
export default {"container":"Nba-z"};